import { render, staticRenderFns } from "./IntegerWidget.vue?vue&type=template&id=ea331f54&"
import script from "./IntegerWidget.vue?vue&type=script&lang=js&"
export * from "./IntegerWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports